import React, { useEffect, useState } from "react";
import "../doctor/components/allpages.css";
import Header from '../../layouts/admin/AdminHeader';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { TableLists } from '../admin/TableLists';
import { useSelector } from "react-redux";
import { removeSelectedIds, selectAuth, setLeadPageRefresh } from "../../redux/slice/authSlice";
import path from "../../path";
import useEncryption from "../../services/useEncryption";
import { createAuditLogs } from "../../api/providerApi/providerApi";
import useHeaders from "../../helpers/useHeaders";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { getAllActiveProviderApi } from "../../api/adminApi/adminApi";
import { useDispatch } from "react-redux";

export const LeadLists = () => {
  const [value, setValue] = useState('All Leads');
  const dispatch = useDispatch();
  const { refresh } = useSelector(selectAuth);
  const [search, setSearch] = useState("");
  const { selctedId } = useSelector(selectAuth); 
  const { encryptData, decryptData } = useEncryption();
  const [ providers, setProviders ] = useState([]);
  const [ providerId, setProviderId ] = useState("");
  const headers = useHeaders();
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRefresh = () => {
  dispatch(setLeadPageRefresh(!refresh));
  dispatch(removeSelectedIds());
  setProviderId('');
};


  const handleSearchChange = (event) => {
    setSearch(event.target.value); 
  };

  const generateFile = async() => {
    try {
      window.location.href = `${path}/v1/lead/csv-export?data=${encodeURIComponent(encryptData(selctedId))}`;
      let obj = {
        event : 'SuperAdmin has download the CSV file for the lead.'
      }
      await createAuditLogs({ data: encryptData(obj)}, headers);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  }

  const fetchData = async () => {
    try {
        const response = await getAllActiveProviderApi( headers )
        const decryptedData = decryptData(response?.data?.data);
        setProviders(decryptedData);      
        // console.log("Providers123:", decryptedData);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
  };

  useEffect(()=>{
    fetchData();
  },[])

  return (
    <div>
      <Header pageTitle="Leads" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">List View</div>
          <div style={{ display: 'flex', gap: '10px' }}>
          {/* <button className="btn blackoutlineBtn" onClick={handleRefresh}>Archive</button> */}
          <button className="btn blackoutlineBtn" onClick={handleRefresh}>Refresh</button>

          </div>
        
        </div>
        <div className="cardcontents">
          <TabContext className="tabsDesigns" value={value}>
            <Tabs className="butoontabdesigns" onChange={handleChange}>
              <Tab className={value === "All Leads" ? "actived" : ""} label="All Leads" value="All Leads" />
              <Tab className={value === "New Lead" ? "actived" : ""} label="New Lead" value="New Lead" />
              <Tab className={value === "Scheduled For Contact" ? "actived" : ""} label="Scheduled For Contact" value="Scheduled For Contact" />
              <Tab className={value === "Contact Attempted" ? "actived" : ""} label="Contact Attempted" value="Contact Attempted" />
              <Tab className={value === "Ready To Schedule" ? "actived" : ""} label="Ready To Schedule" value="Ready To Schedule" />
              <Tab className={value === "In Process" ? "actived" : ""} label="In Process" value="In Process" />
              <Tab className={value === "Scheduled" ? "actived" : ""} label="Scheduled" value="Scheduled" />
              <Tab className={value === "UnScheduled" ? "actived" : ""} label="Unscheduled" value="UnScheduled" />
              <Tab className={value === "Archived" ? "actived" : ""} label="Archived" value="Archived" />

            </Tabs>

          
            <TabPanel className="tabpanelControl" value={value}>
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex">
                      <div className="searchBar searchbar-space">
                        <input 
                          type="text" 
                          autoComplete="off" 
                          placeholder="Search" 
                          value={search}
                          onChange={handleSearchChange} 
                        />
                      </div>
                        <div className="formdesign">
                          <FormControl sx={{  minWidth: 160 }} size="small">
                           <InputLabel id="location-label">Select Location</InputLabel>
                            <Select
                              labelId="location-label"
                              id="location"
                              name="location"
                              label="Select Location"
                              value={providerId}
                              onChange={(e)=>{
                                setProviderId(e.target.value);
                              }}
                            >
                              {providers.map((provider) => (
                                <MenuItem key={provider.id} value={provider.id}>
                                    {provider.organizationName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                  </div>
                  
                  <button className="btn blackoutlineBtn" onClick={generateFile}>Download CSV</button>
                </div>                  
                <TableLists activeTab={value} refresh={refresh} key={refresh} search={search} providerId={providerId}/>
              </div>
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>
  );
};
